import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { Options } from 'selenium-webdriver';
import { AppSettings } from '../../common/entities/AppSettings';
import { UserAuthResponse } from '../../common/entities/IUserAuthResponse';
import { ReportDefinition } from '../../common/entities/ReportDefinition';

@Injectable()
export class UserAuthService {
    public loginAuthResponse;
    public organizationGUID;
    public sessionKey;
    public userName;
    public userRoles;
    public ifShowDashboard = false;
    // public baseUrl: string = AppSettings.API_ENDPOINT;
  //public baseUrl =  "https://localhost:44399/"   //Local URL
   // public baseUrl = "http://aa151035-blr:8050/" //local IIS
    // public baseUrl = "http://aa171232-blr:8050/" //Virinchi's Local ISI
    // public baseUrl = "http://al190804-blr:8096/" // hanumanth local IIS
    // public baseUrl: string = window.location.origin + "/";    
    
    // public baseUrl = 'https://vitalsuppliesapi.vitalaxis.com/';
  //  public baseUrl : string = "https://vitalsupplies-api.azurewebsites.net/"   //Production URL

 public baseUrl = "https://vitalsupplies-stage.azurewebsites.net/" //Real Staging URL 
    constructor(private http: HttpClient) {

    }

    CoreAuthentication(queryString: string): Observable<UserAuthResponse> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post<UserAuthResponse>(this.baseUrl + `UserAuth/CoreAuthentication?` + queryString, null, httpOptions).pipe(catchError(this.handleError));
    }

    CRMAuthentication(Roles: string, AppType: string, agentOrgGUID: string) {
        let queryString = `Roles=` + Roles + `&AppType=` + AppType + `&agentOrgGUID=` + agentOrgGUID;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post<UserAuthResponse>(this.baseUrl + `UserAuth/CRMAuthentication?` + queryString, null, httpOptions).pipe(catchError(this.handleError));
    }


    LoginAuth(cred) {
        return this.http.post<any>(`${this.baseUrl}api/v1/Search/LoginAuth`, cred);
    }


    GetSessionKey(data) {
        return this.http.post<any>(`${this.baseUrl}api/v1/Search/GetSessionKey`, data);
    }


    GetCRMJSONFromCoreSessionToken(sessiontoken: string): Observable<string> {
        let sessionTokenURL: string = AppSettings.GET_CORE_AUTH_SESSIONTOKEN_URL;
        let code: string = '';
        let EncryptionKey: string = '';
        sessionTokenURL += `/api/cache/get?code=HBCkdm1GBErCakJ0AaALjVMUAve0dk018mSzcBwRuYDmz36oatIvoA==&sessiontoken=` + sessiontoken;
        return this.http.get<string>(sessionTokenURL);
    }

    SSOAuthentication(url: string, jsonPayload: any): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'accept': 'application/json',
            })
        };
        return this.http.post<string>(url, jsonPayload, httpOptions);
    }

    private handleError(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Client Side Error :', errorResponse.error.message);
        } else {
            console.error('Server Side Error :', errorResponse);
        }
        return _throw('There is a problem with the service. We are notified & working on it. Please try again later.');
    }
}